// Premium branded loader: logo inside a rotating cyan ring with a pulsing glow.
export default function BrandLoader() {
  return (
    <div role="status" aria-label="Loading" className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-background">
      <div className="relative w-28 h-28 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full bg-primary/10 blur-2xl animate-pulse" />
        <div className="absolute inset-0 rounded-full border border-primary/15" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-primary border-r-primary/40 animate-spin" style={{ animationDuration: '1.1s' }} />
        <div className="absolute inset-3 rounded-full border border-transparent border-b-primary/70 animate-spin" style={{ animationDuration: '1.8s', animationDirection: 'reverse' }} />
        <img
          src="https://media.base44.com/images/public/69f7328a281ea086a55ced65/e73f4b1ea_Untitled-2.png"
          alt=""
          className="w-12 h-12 object-contain animate-pulse"
        />
      </div>
      <span className="mt-8 font-inter font-bold text-sm tracking-[0.5em] uppercase text-foreground pl-[0.5em]">Jotunheims</span>
      <div className="mt-4 w-40 h-px bg-border overflow-hidden relative">
        <div className="absolute inset-y-0 w-1/3 bg-gradient-to-r from-transparent via-primary to-transparent animate-[jh-bar_1.4s_ease-in-out_infinite]" />
      </div>
      <style>{`@keyframes jh-bar{0%{left:-35%}100%{left:100%}}`}</style>
    </div>
  );
}